import { compose, setDisplayName, withProps } from 'recompose';
import { always, applySpec, identity, ifElse, map, prop } from 'ramda';

import StoreBadge from '#src/components/StoreBadge';
import {
  selectFields,
  selectContentType,
  selectField,
} from '#src/lib/contentful/selectors.mjs';

import Link from '../../../Link';
import RichText from '../../../RichText';

const componentMap = (item) => {
  const contentType = selectContentType(item);

  // const components = {
  //   hubRichText: (item) => <RichText content={...item} />,
  //   link: (item) => <Link link={...item} />,
  //   appStoreBadge: (item) => <Link link={...item} />
  // };

  if (contentType === 'hubRichText') {
    return {
      Component: RichText,
      props: { content: { ...item } },
    };
  } else if (contentType === 'link') {
    return {
      Component: Link,
      props: { link: { ...item } },
    };
  } else if (contentType === 'appStoreBadge') {
    return {
      Component: StoreBadge,
      props: { badge: selectFields(item) },
    };
  }
};

const items = compose(
  ifElse(identity, map(componentMap), always([])),
  selectField('items')
);

const props = compose(
  applySpec({
    name: selectField('name'),
    items,
  }),
  prop('category')
);

export const enhance = compose(
  setDisplayName('CategoryEnhanced'),
  withProps(props)
);
